import React from 'react';
import { BasicInfoIcon } from '../../Icons/OfferIcons';
import styles from './BasicPlanOfferIcons.module.scss';

function BasicPlanOfferIcons() {
  return <BasicInfoIcon className={styles.basicPlanIcons} />;
}
export default BasicPlanOfferIcons;
